export interface WizardDepartment {
  id?: number
  department_id: string
  name: string
  code: string
  description: string
  sub_departments: WizardSubDepartment[]
}

export interface WizardSubDepartment {
  id?: number
  sub_department_id: string
  name: string
  keywords: string[]
  default_priority: string
  description: string
  is_default: boolean
}

export interface WizardIntent {
  id?: number
  intent_id: string
  name: string
  description: string
  examples: string[]
  indicators: string[]
  workflow: string
  priority: number
  is_default: boolean
  require_address_verification: boolean
}

export interface WizardServiceArea {
  enabled: boolean
  city_name: string
  description: string
  allowed_zip_codes: string
  center_lat: number
  center_lng: number
  default_zoom: number
  bounds_north: number
  bounds_south: number
  bounds_east: number
  bounds_west: number
  skip_address_validation: boolean
}

export interface WizardData {
  configName: string
  provider: string
  model: string
  sessionTTL: number
  enableSRO: boolean
  departments: WizardDepartment[]
  intents: WizardIntent[]
  app_connection_id: number | null
  serviceArea: WizardServiceArea
}

export const INITIAL_WIZARD_DATA: WizardData = {
  configName: '',
  provider: 'openai',
  model: 'gpt-4o-mini',
  sessionTTL: 1800,
  enableSRO: true,
  departments: [],
  intents: [],
  app_connection_id: null,
  serviceArea: {
    enabled: false,
    city_name: '',
    description: '',
    allowed_zip_codes: '',
    center_lat: 0,
    center_lng: 0,
    default_zoom: 12,
    bounds_north: 0,
    bounds_south: 0,
    bounds_east: 0,
    bounds_west: 0,
    skip_address_validation: false,
  },
}

export const WIZARD_STEPS = [
  { id: 1, key: 'basics', label: 'Basics', description: 'Name, model & session' },
  { id: 2, key: 'departments', label: 'Departments', description: 'Routing structure' },
  { id: 3, key: 'intents', label: 'Intents', description: 'Message classification' },
  { id: 4, key: 'integration', label: 'Connection', description: 'App connection' },
  { id: 5, key: 'service-area', label: 'Service Area', description: 'Optional boundaries' },
  { id: 6, key: 'review', label: 'Review', description: 'Confirm & save' },
] as const

export type StepKey = typeof WIZARD_STEPS[number]['key']
